import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addRouter from "./components/addRouter";
export default {
  name: "routes",
  components: {
    addRouter: addRouter
  },
  data: function data() {
    return {
      showing: false,
      roterShow: false,
      threeShow: false,
      fourShow: false,
      fiveShow: false,
      showmask: false,
      firstRoutes: [],
      secondRoutes: [],
      threeRoutes: [],
      fourRouts: [],
      fiveRoutes: [],
      addRouter: false,
      userGame: false,
      total: 0,
      page: 1,
      currentIndex: 0,
      DadId: 0,
      // 点击的父路由ID
      Dindex: 0,
      // 点击的父路由索引
      Tibdex: 0,
      Tindex: 0,
      parentid: 0,
      //层级
      Foudex: 0,
      fivdex: 0,
      queryRouter: [],
      //sumRouter
      // secondParentid:0,//二级层级
      secondIndex: 0,
      threeIndex: 0,
      fourIndex: 0,
      fiveIndex: 0,
      loginForm: {
        username: "",
        password: ""
      },
      height: 600
    };
  },
  created: function created() {
    this.getData();
    this.DadId = 0; // 初始化父级显示id为26的数据中心路由

    this.currentIndex = 0; // 初始化父级显示id为26的数据中心路由

    this.$nextTick(function () {
      var height = document.getElementById('auto');
    });
  },
  mounted: function mounted() {
    this.loginForm = JSON.parse(localStorage.getItem("UserIfo"));
  },
  methods: {
    handleSource: function handleSource(id) {
      this.$refs.addRouter.init(id);
    },
    // click one
    liClick: function liClick(i, index, parentid) {
      this.showing = true;
      this.threeShow = false;
      this.fourShow = false;
      this.parentid = parentid;
      this.Dindex = i;
      this.currentIndex = index;
      var arr = this.firstRoutes.filter(function (p) {
        return p.id == index;
      });
      this.secondRoutes = arr[0].son;
      this.DadId = arr[0].id;
    },
    newRouter: function newRouter(router) {
      var _this = this;

      var res = [];
      router.forEach(function (item) {
        item.son_menu = item.son || [];

        if (item.son.length) {
          _this.newRouter(item.son);
        }

        res.push(item);
      });
      return res;
    },
    getData: function getData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var query;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$api.routesList();

              case 2:
                query = _context.sent;
                _this2.firstRoutes = query.data;
                console.log(query);
                _this2.secondRoutes = query.data[_this2.Dindex].son;
                _this2.threeRoutes = query.data[_this2.Dindex].son[_this2.Tindex].son;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // click two
    secClick: function secClick(item, index) {
      this.threeShow = true;
      this.fourShow = false;
      this.parentid = item.parentid;
      this.secondIndex = item.id;
      this.Tindex = index;
      var arr = this.secondRoutes.filter(function (p) {
        if (item.id == p.id) {
          return p;
        }
      });
      this.threeRoutes = arr[0].son;
      this.Tibdex = arr[0].id;
    },
    // async getThreeRputer() {
    //   const query = await this.$store.dispatch("user/routesList", {
    //     page: this.page,
    //   });
    //   this.queryRouter = query;
    //   this.threeRoutes = query[this.Tindex].son; // 显示的三级子路由列表，根据父级路由的index进行展示
    //   this.$set(this.threeRoutes);
    //   // this.$set(this.secondRoutes);
    // },
    // click three
    threeClick: function threeClick(item, index) {
      this.fourShow = true;
      this.parentid = item.parentid;
      this.threeIndex = index;
      var arr = this.threeRoutes.filter(function (p) {
        if (item.id == p.id) {
          return p;
        }
      });
      this.fourRouts = arr[0].son;
      this.Foudex = arr[0].id; // this.fourRouts = this.queryRouter[this.Foudex].son;
    },
    // four
    fourClick: function fourClick(item, index) {
      this.fiveShow = true;
      this.parentid = item.parentid;
      this.fourIndex = index;
      var arr = this.fourRouts.filter(function (p) {
        if (item.id == p.id) {
          return p;
        }
      });
      this.fiveRoutes = arr[0].son;
      this.fivdex = arr[0].id;
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm("此操作将删除该路由, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.$api.delRouter({
                  id: id
                });

              case 2:
                _this3.$message({
                  type: "success",
                  message: "删除成功!"
                });

                _this3.getData();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    topclick: function topclick(i, id, index) {
      var _this4 = this;

      this.currentIndex = this.DadId;
      this.$api.getroutes({
        parent_id: this.DadId,
        id: id,
        orderby: i
      }).then(function (res) {
        if (res.status == 200) {
          _this4.getData();
        }
      }); // this.getData();
    },
    bottomclick: function bottomclick(i, id, index) {
      var _this5 = this;

      // 子向下标记与ID
      this.currentIndex = this.DadId;
      this.$api.getroutes({
        parent_id: this.DadId,
        id: id,
        orderby: i
      }).then(function (res) {
        if (res.status == 200) {
          _this5.getData();
        }
      });
    }
  }
};